export default (builder) =>
  builder.mutation({
    query: (emailPayload) => ({
      url: 'send-email',
      method: 'POST',
      body: emailPayload,
    }),
  });
